import React, { useState, useEffect } from "react";
import Constants from "../constants/Constants";
import { navigate } from "@reach/router";
import { MdSecurity } from "react-icons/md";
import { SiWebauthn } from "react-icons/si";
import { ImEye, ImEyeBlocked } from "react-icons/im";
import ReCAPTCHA from "react-google-recaptcha";

import "../css/login.css";
const Login = ({ attemptToLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState("");
  const [toText, setToText] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [code, setCode] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [capValue, setCapValue] = useState("");
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [authDevice, setAuthDevice] = useState(false);
  const [sendToSupport, setSendToSupport] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [loginError, setLoginError] = useState("");
  useEffect(() => {
    const testCap = localStorage.getItem("safcap");
    if (testCap && testCap === "yes") {
      setShowCaptcha(true);
    }
  }, []);
  const badLogin = (msg) => {
    setSubmitting(false);
    setLoginError(msg);
    setToText(true);
  };
  const resetCaptcha = () => {
    setShowCaptcha(false);
    setTimeout(() => {
      setShowCaptcha(true);
      setCapValue("");
    }, 300);
  };
  const handleFailedAuthDevice = () => {
    setAttempts((prev) => prev + 1);
    setCode("");
    setHasError(true);
    setSubmitting(false);
  };
  const handleLoginSuccess = (res) => {
    if (res && "ditkils" in res) {
      if (res.ditkils !== "pin") {
        localStorage.setItem("ditkils", res.ditkils);
      }
    }
    localStorage.removeItem("safcap");
    attemptToLogin();
    //not sure I need this.
    navigate(`${Constants.MA}subscriptions`);
  };
  const authDeviceNotWorking = () => {
    setAuthDevice(true);
    sendToSupport(true);
    badLogin(
      "Please contact support about your issues not recieving your auth code AND OR your auth code not working."
    );
  };
  const handleAuthDevice = () => {
    //handle
    if (submitting) return;
    setSubmitting(true);
    fetch(`https://addfriends.com/authorize_device`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code: parseInt(code) }),
    })
      .then((res) => {
        if (res.status === 502) {
          return false;
        }
        return res.json();
      })
      .then((res) => {
        if (typeof res === "boolean") {
          if (attempts < 5) {
            handleFailedAuthDevice();
          } else {
            authDeviceNotWorking();
          }
          return;
        }
        //handle
        if ("error" in res) {
          //failed try again...
          if (attempts < 5) {
            handleFailedAuthDevice();
            return;
          } else {
            authDeviceNotWorking();
            return;
          }
        }
        handleLoginSuccess(res);
      })
      .catch((err) => {
        if (attempts < 5) {
          handleFailedAuthDevice();
        } else {
          authDeviceNotWorking();
        }
      });
  };
  const loginAttempt = () => {
    //handle
    if (submitting) return;
    setSubmitting(true);
    if (username === "" || password === "") {
      badLogin("Please fill in your username / password.");
      return;
    }
    let d = localStorage.getItem("ditkils");
    let finalPin = pin === "" ? 0 : parseInt(pin);
    let final_pass = password.replace(/&/g, "&amp;");
    const loginCreds = {
      username: username,
      password: final_pass,
      fp: d
        ? d
        : Math.random()
            .toString(36)
            .substring(7),
      cap: capValue,
      pin: finalPin,
    };

    fetch(`https://addfriends.com/login`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginCreds),
    })
      .then((res) => {
        //handle
        if (res.status === 429) {
          return 1;
        }
        if (res.status === 502) {
          //not sure what this is...
          return 2;
        }
        if (res.status === 500) {
          //not sure what this is...
          return 2;
        }
        return res.json();
      })
      .then((res) => {
        //handle
        if (typeof res === "number") {
          switch (res) {
            case 1:
              //being rate limited
              badLogin(
                "You have tried to login too many times, I think its time to ask for some help!"
              );
              setSendToSupport(true);
              break;
            case 2:
              //server error
              badLogin("The server is having a issue, the geeks are on it!");
              break;
            default:
              //Bad Username Or Password
              if (loginAttempts < 5) {
                badLogin("Incorrect Username OR Password!");
                setLoginAttempts((prev) => prev + 1);
                if (showCaptcha) {
                  resetCaptcha();
                }
              } else {
                badLogin("Error Code: 83hsk");
                setSendToSupport(true);
              }

              break;
          }
          return;
        }
        if ("error" in res) {
          //Something went wrong we gotta handle here...
          if (res.error === "Login Failed") {
            //bad username or password CORRECT
            //if res.info === 1 && captcha is no popped pop it please.
            if (res.info === 1 && showCaptcha === false) {
              setShowCaptcha(true);
              localStorage.setItem("safcap", "yes");
            } else {
              resetCaptcha();
            }
            if (loginAttempts < 5) {
              setLoginAttempts((prev) => prev + 1);
              badLogin("Incorrect Username OR Password!");
            } else {
              badLogin("long info"); //
              setSendToSupport(true);
            }

            return;
          }

          if (res.error === "Auth Device") {
            //Need to Auth Device...
            setAuthDevice(true);
            //res.info = memberid
            setSubmitting(false);
            return;
          }

          if (res.error === "Auth Device Failed") {
            badLogin(
              "We were unable to send an auth code to your email address.  Please get into contact with support direct via email service@addfriends.com"
            );
            return;
          }
          let no_double = true;
          if (showCaptcha === false) {
            //this is bad google captcha CORRECT
            setShowCaptcha(true);
            localStorage.setItem("safcap", "yes");
            no_double = false;
          }

          if (loginAttempts < 5) {
            if (no_double) {
              resetCaptcha();
            }
            setLoginAttempts((prev) => prev + 1);
            badLogin("Captcha is needed for your login, please try again.");
          } else {
            badLogin(
              "Looks like the captcha is broken or maybe you are having a hard time solving it.  Please contact support about this issue, error code: 181."
            );
            setSendToSupport(true);
          }

          return;
        }

        //this is sucess;
        handleLoginSuccess(res);
      });
  };

  return (
    <div>
      <div>
        <div className="header_logo larger">
          <em>+</em>Add<strong>Friends</strong>.com<span>members area</span>
        </div>
      </div>
      {authDevice ? (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div className="form_field" style={{ maxWidth: 500, width: "100%" }}>
            <div className="explain">
              This seems to be a new device, we've sent an email to the address
              we have on file with an auth code. Please input it below.
            </div>
            {hasError && (
              <div className="authError">
                That wasn't it, try again or if you feel like it was correct
                then please{" "}
                <a href="https://addfriends.com/contact-us">contact support</a>.
              </div>
            )}

            <div className="row">
              <div className="col second" style={{ marginLeft: 0 }}>
                <div className="icon">
                  <MdSecurity size={18} />
                </div>
                <input
                  type="text"
                  className="input"
                  disabled=""
                  value={code}
                  onChange={(e) => setCode(e.target.value.trim())}
                  placeholder="Auth Code"
                  required
                  autoComplete="on"
                />
              </div>
            </div>

            <div className="loginBtn auth" onClick={handleAuthDevice}>
              {submitting ? (
                <div className="nk-spinner loggingIn" />
              ) : (
                "Auth Device"
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div className="form_field" style={{ maxWidth: 450, width: "100%" }}>
            {loginError !== "" && (
              <div className={sendToSupport ? "authError white" : "authError"}>
                {loginError === "long info" ? (
                  <span>
                    It looks like you are having trouble accessing your account.
                    It could be your username <strong>OR</strong> password so
                    please verify both. If you don't know your username please
                    contact support below. You can always try and{" "}
                    <a href="https://addfriends.com/reset-password/">
                      reset your password
                    </a>{" "}
                    if you think that that maybe the issue.
                  </span>
                ) : (
                  loginError
                )}
              </div>
            )}
            {sendToSupport ? (
              <div className="loginBtn green">
                <a href="https://addfriends.com/contact-us">Go To Support</a>.
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="col second" style={{ marginLeft: 0 }}>
                    <div className="icon">
                      <i className="icon-email"></i>
                    </div>
                    <input
                      type="text"
                      className="input"
                      disabled=""
                      value={username}
                      onChange={(e) => setUsername(e.target.value.trim())}
                      placeholder="Username"
                      required
                      autoComplete="on"
                    />
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col second grid_control"
                    style={{ marginLeft: 0 }}
                  >
                    <div
                      className="icon"
                      onClick={() => setToText((prev) => !prev)}
                      style={{ cursor: "pointer" }}
                    >
                      {toText ? (
                        <ImEyeBlocked size={18} />
                      ) : (
                        <ImEye size={18} />
                      )}
                    </div>
                    <input
                      type={toText ? "text" : "password"}
                      className="input input_control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value.trim())}
                      placeholder="Password"
                      required
                      autoComplete="current-password"
                    />
                    <div className="hide_accept">
                      <i className="icon-save"></i>
                    </div>
                  </div>
                </div>

                {showPin && (
                  <div className="row">
                    <div
                      className="col second grid_control"
                      style={{ marginLeft: 0 }}
                    >
                      <div className="icon">
                        <SiWebauthn size={18} />
                      </div>
                      <input
                        type="number"
                        className="input input_control"
                        value={pin}
                        onChange={(e) => setPin(e.target.value.trim())}
                        placeholder="Pin"
                        autoFocus
                      />
                    </div>
                  </div>
                )}
                <div className="usePin">
                  <input
                    type="checkbox"
                    id="pin"
                    onClick={(e) => setShowPin(e.target.checked)}
                  />
                  <label htmlFor="pin"> Use pin code</label>
                </div>
                {showCaptcha && (
                  <div className="captcha">
                    <ReCAPTCHA
                      sitekey="6LfHbNAaAAAAANZ4dNkFSTEmvQIYgwg96C0avZ0k"
                      onChange={(v) => setCapValue(v)}
                      theme="dark"
                    />
                  </div>
                )}
                <div className="bottom" style={{ marginTop: 20 }}>
                  <a href="/reset-password/">Forgot Password?</a>
                </div>
                <div className="loginBtn" onClick={loginAttempt}>
                  {submitting ? (
                    <div className="nk-spinner loggingIn" />
                  ) : (
                    "Login"
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
